import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import getKhattabat102Store from "../../../../../../../stores/khattabat-stores/102-stores";
import { TGender } from "../../../../../../../Types";

import {
  TKhattabatOneOTwoMessageReaction
} from "../../../../../../../types/khattabat-one-o-two-message.type";


const ReactionBadge = withLiteObserverAndTheme<{
  reaction: TKhattabatOneOTwoMessageReaction;
  count: number;
  reactorGender: TGender;
}>((props) => {
  const { reaction, count, reactorGender, theme } = props;
  const { colors } = theme;
  const backgroundColor =
    reactorGender === "m" ? colors.all.paleSkyBlue : colors.all.palePink;

  return (
    <div
      style={{
        minWidth: 36,
        height: 34,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
        paddingLeft: 7,
        paddingRight: 7,
        backgroundColor,
        borderRadius: 9,
        boxSizing: "border-box"
      }}
    >
      <span
        style={{
          fontSize: 20,
          lineHeight: "22px"
        }}
      >
        {reaction.reaction}
      </span>

      {count > 1 ? (
        <span
          style={{
            fontSize: 12,
            lineHeight: "14px",
            fontWeight: 700
          }}
        >
          {count}
        </span>
      ) : null}
    </div>
  );
});

const OneOTwoMessageReactions = withLiteObserverAndTheme<{
  conversationID: string;
  messageId: number;
}>((props) => {
  const { conversationID, messageId } = props;
  const { displayedReactions, isMerged } = getKhattabat102Store(
    conversationID
  ).getDisplayedMessageReactions(messageId);

  if (displayedReactions.length === 0) {
    return null;
  }

  if (isMerged) {
    return (
      <ReactionBadge
        reaction={displayedReactions[0].reaction}
        count={displayedReactions[0].count}
        reactorGender={displayedReactions[0].reactorGender}
      />
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 8,
        width: "fit-content"
      }}
    >
      {displayedReactions.map((displayedReaction) => (
        <ReactionBadge
          key={displayedReaction.reaction.senderUUID}
          reaction={displayedReaction.reaction}
          count={displayedReaction.count}
          reactorGender={displayedReaction.reactorGender}
        />
      ))}
    </div>
  );
});

export default OneOTwoMessageReactions;
